import 'chosen';

const initChosen = function initChosen() {
  const $select = $('select');
  if ($select.length > 0) {
    // select menu

    $('.chzn-select').on('change', (evt) => {
      $(evt.target).next('.chzn-container').removeClass('is-placeholder');
    });

    $('.chzn-select').chosen();
    $('.chzn-select-deselect').chosen({ allow_single_deselect: true });

    if ($('.chzn-select').val() === '') {
      $('.chzn-select').next('.chzn-container').addClass('is-placeholder');
    }
  }
};
initChosen();

Sys.WebForms.PageRequestManager.getInstance().add_endRequest(initChosen);
